import { useEffect, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import instance, { setAuthToken } from "../services/api";
import XDataGrid from "../components/XDataGrid";
import AddCustomer from "../components/AddCustomer";
import ConfirmationDialog from "../components/ConfirmationDialog";
// import CustomersSummary from "../components/CustomersSummary";
// import FarmersSummary from "../components/FarmersSummary";

export default function Customers() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  const initCustomers = () => {
    setLoading(false);
    setAuthToken(localStorage.getItem("token"));
    instance
      .get("/customer/list/")
      .then((response) => {
        setLoading(false);
        setCustomers(
          response.data.results.map((customer) => {
            customer.id = customer.uuid;
            return customer;
          })
        );
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    initCustomers();
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const add = () => {
    handleClickOpen();
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  const onDelete = (id) => {
    setDeletingId(id);
    setDeleteConfirmation(true);
  };

  const onDeleteConfirm = () => {
    setAuthToken(localStorage.getItem("token"));
    instance.delete("/admin/update_user/" + deletingId + "/").then(() => {
      setSnackbar(true);
      setSnackBarMsg("Customer deleted successfully.");
      setSnackBarSeverity("success");
      handleDeleteConfirmClose();
      initCustomers();
    });
  };

  const [openSnackbar, setSnackbar] = useState(false);
  const [snackBarSeverity, setSnackBarSeverity] = useState("success");
  const [snackBarMsg, setSnackBarMsg] = useState(false);
  const handleSnackbarClose = () => {
    setSnackbar(false);
    setSnackBarSeverity("success");
    setSnackBarMsg("");
  };

  const handleDeleteConfirmClose = () => {
    setDeleteConfirmation(false);
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>{loading && <LinearProgress />}</Box>
      <XDataGrid
        data={customers}
        add={add}
        onDelete={onDelete}
        loading={loading}
        refetch={initCustomers}
      />
      {open && (
        <AddCustomer
          open={open}
          onClose={handleClose}
          refetch={initCustomers}
        />
      )}
      {deleteConfirmation && (
        <ConfirmationDialog
          title={"Delete Customer"}
          onOkay={onDeleteConfirm}
          keepMounted
          open={deleteConfirmation}
          onClose={handleDeleteConfirmClose}
        />
      )}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={openSnackbar}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleClose} severity={snackBarSeverity}>
          {snackBarMsg}
        </Alert>
      </Snackbar>
    </>
  );
}
